import { render } from "./PageWrapper.vue?vue&type=template&id=c7b8eda0&scoped=true&ts=true"
import script from "./PageWrapper.vue?vue&type=script&lang=ts"
export * from "./PageWrapper.vue?vue&type=script&lang=ts"

import "./PageWrapper.vue?vue&type=style&index=0&id=c7b8eda0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b8eda0"]])

export default __exports__